// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1n_Lz","inner":"Footer_inner__24y3R"};